import { connect } from 'react-redux';
import { compose } from 'redux';
import { defineMessages, injectIntl } from 'react-intl';
import _isNumber from 'lodash/isNumber';

import { selectActiveVenue } from 'selectors/general';
import { withOpportunityShownTracking } from 'helpers/events';

import { selectOpportunities } from './Opportunities.selectors';
import { actOnOpportunity, rejectOpportunity } from './Opportunities.saga';
import Opportunity from './Opportunity';

export const messages = defineMessages({
  buttonSuccess: {
    id: 'opportunities.opportunity-container.button-success',
    defaultMessage: '{recommendation, plural, one {# spot} other {# spots}} added',
  },
  buttonOpenAndAdd: {
    id: 'opportunities.opportunity-container.button-open-and-add',
    defaultMessage: 'Open and add {recommendation, plural, one {# spot} other {# spots}}',
  },
  buttonAdd: {
    id: 'opportunities.opportunity-container.button-add',
    defaultMessage: 'Add {recommendation, plural, one {# spot} other {# spots}}',
  },
  xofyCP: {
    id: 'opportunies.opportunity.xofy-cp',
    defaultMessage: '{totalClasspassReservations, number} of {derivedCapacity, number}',
  },
  xofyCPDisabled: {
    id: 'opportunities.opportunity-container.note-disabled',
    defaultMessage: '{totalClasspassReservations, number} of {derivedCapacity, number} · Not on ClassPass',
  },
  xofyCPNoSpots: {
    id: 'opportunities.opportunity-container.note-no-spots',
    defaultMessage: '{totalClasspassReservations, number} of {derivedCapacity, number} · No spots',
  },
  xofyCPSoldOut: {
    id: 'opportunities.opportunity-container.note-sold-out',
    defaultMessage: '{totalClasspassReservations, number} of {derivedCapacity, number} · Sold out',
  },
  xofyCPOnlyOne: {
    id: 'opportunities.opportunity-container.note-only-one',
    defaultMessage: '{totalClasspassReservations, number} of {derivedCapacity, number} · Only 1 left',
  },
});

const mapStateToProps = (state, ownProps) => {
  const { isSuccess, opportunity, updatedCapacity } = ownProps;
  const { scheduleDisabled, totalClasspassCapacity, totalClasspassReservations } = opportunity;
  const { venueId, currencyCode } = selectActiveVenue(state);
  const { data: opportunities } = selectOpportunities(state);

  let buttonMessage;
  if (isSuccess) {
    buttonMessage = messages.buttonSuccess;
  } else if (scheduleDisabled) {
    buttonMessage = messages.buttonOpenAndAdd;
  } else {
    buttonMessage = messages.buttonAdd;
  }

  const derivedCapacity = _isNumber(updatedCapacity)
    ? totalClasspassCapacity + updatedCapacity
    : totalClasspassCapacity;

  let xofyCPMessage = messages.xofyCP;
  if (scheduleDisabled) {
    xofyCPMessage = messages.xofyCPDisabled;
  } else if (totalClasspassReservations === 0 && derivedCapacity === 0) {
    xofyCPMessage = messages.xofyCPNoSpots;
  } else if (totalClasspassReservations === derivedCapacity) {
    xofyCPMessage = messages.xofyCPSoldOut;
  } else if (derivedCapacity - totalClasspassReservations === 1) {
    xofyCPMessage = messages.xofyCPOnlyOne;
  }

  return {
    buttonMessage,
    currencyCode,
    derivedCapacity,
    xofyCPMessage,
    opportunities,
    venueId,
  };
};

const mapDispatchToProps = {
  unboundActOnOpportunity: actOnOpportunity,
  unboundRejectOpportunity: rejectOpportunity,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { opportunities, venueId, ...restStateProps } = stateProps;
  const {
    opportunity: {
      className,
      startTime,
      id: opportunityId,
      recommendation: spotsAdded,
      scheduleId,
      opportunitySource,
      totalClasspassCapacity,
    },
  } = ownProps;
  const { unboundActOnOpportunity, unboundRejectOpportunity } = dispatchProps;
  return {
    actOnOpportunity: unboundActOnOpportunity.bind(
      null,
      venueId,
      opportunities,
      scheduleId,
      spotsAdded,
      className,
      startTime,
      opportunitySource,
      totalClasspassCapacity
    ),
    rejectOpportunity: unboundRejectOpportunity.bind(null, venueId, scheduleId, opportunityId),
    ...restStateProps,
    ...ownProps,
  };
};

export default compose(
  withOpportunityShownTracking,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  injectIntl
)(Opportunity);
